import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HomePage } from './home';
import { TranslateModule } from '@ngx-translate/core'; // Required for translation.
import { ComponentsModule } from '../../components/components.module';
import { MatFormFieldModule, MatTableModule, MatPaginatorModule, MatSortModule, MatInputModule, MatCheckboxModule, MatToolbarModule, MatButtonModule, MatIconModule, MatListModule, MatAutocompleteModule, MatTabsModule, MatCardModule } from '@angular/material';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
  declarations: [
    HomePage,
  ],
  imports: [
    IonicPageModule.forChild(HomePage),
    TranslateModule.forChild(), // Required for translation.
    ComponentsModule,
    FileUploadModule,
    MatFormFieldModule, MatTableModule, MatPaginatorModule, MatSortModule, MatInputModule, MatCheckboxModule, MatToolbarModule, MatButtonModule, MatIconModule, MatListModule, MatAutocompleteModule, MatTabsModule, MatCardModule
  ],
  exports: [
    HomePage
  ]
})
export class HomePageModule {}



// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts